document.addEventListener("DOMContentLoaded", function () {
    const sizeButtons = document.querySelectorAll(".size-button");
    const variantInput = document.getElementById("selected-variant-id");
    const checkoutButton = document.getElementById("checkout-button");
    const addToCartButton = document.querySelector(".add-to-cart");
    const addToCartText = addToCartButton.querySelector("span");

    function updateCheckoutUrl(variantId) {
        checkoutButton.href = `/cart/${variantId}:1`;
    }

    updateCheckoutUrl(variantInput.value);

    sizeButtons.forEach(button => {
        button.addEventListener("click", function () {
            sizeButtons.forEach(btn => btn.classList.remove("selected"));
            this.classList.add("selected");
            variantInput.value = this.dataset.variantId;
            updateCheckoutUrl(this.dataset.variantId);
        });
    });

    addToCartButton.addEventListener("click", function () {
        const originalText = addToCartText.textContent;
        addToCartText.textContent = "Adding to cart...";
        
        setTimeout(() => {
            addToCartText.textContent = originalText;
        }, 500);
    });
});